import { FormattedMessage } from "react-intl";
import { Button } from "@shltelemedicine/shl-ui-lib";
import activateIcon from "../../../../assets/buttons/activate.svg";
import deactivateIcon from "../../../../assets/buttons/deactivate.svg";

type ToggleUserActiveButtonProps = {
  isUserActive?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  visible?: boolean;
};

const ToggleUserActiveButton = ({
  isUserActive,
  disabled,
  onClick,
  visible,
}: ToggleUserActiveButtonProps) => (
  <Button
    bgColor="transparent linear-gradient(180deg, #505F95 0%, #2C449A 100%) 0% 0% no-repeat padding-box"
    icon={{
      src: !isUserActive ? activateIcon : deactivateIcon,
      width: 20,
      height: 20,
    }}
    disabled={disabled}
    onClick={onClick}
    style={{
      visibility: !visible ? "hidden" : "visible",
    }}
    className={isUserActive ? "px-2" : undefined}
  >
    <span className="capitalized">
      <FormattedMessage
        id={!isUserActive ? "USER_DETAILS.ACTIVATE" : "USER_DETAILS.DEACTIVATE"}
        defaultMessage={!isUserActive ? "Activate" : "Deactivate"}
      />
    </span>
  </Button>
);
export default ToggleUserActiveButton;
